import { Navigate, useLocation } from "react-router-dom";
import { haIniciadoSesion } from "../services/authService";

const RutaProtegida = ({ children }) => {
    const location = useLocation();

    if (!haIniciadoSesion()) {
        return <Navigate to="/login" state={{ desde: location.pathname }} replace />;
    }

    return children;
}

export default RutaProtegida;
